import { AxiosError } from '@astronautsid/wpe-utils'

import { getParsedErrorResponse } from 'helpers/errorMsg'
import { log } from 'utils/helpers/dataDogLog'

const { REACT_APP_DATADOG_LOG_HTTP_CODE } = process.env

export const axiosErrorLoggerInterceptor = async (err: AxiosError) => {
  const errorStatusCodes = REACT_APP_DATADOG_LOG_HTTP_CODE
    ? REACT_APP_DATADOG_LOG_HTTP_CODE.split(',')
    : []

  const allowLogging =
    err.response &&
    !!errorStatusCodes.length &&
    errorStatusCodes.includes(String(err.response.status))

  if (err.isAxiosError && allowLogging) {
    const httpMethod = err.config?.method
    const httpUrl = err.config?.url
    const httpBody = err.config?.data

    // Server was able to send us a response, so this is an API Error.
    if (err.response) {
      const message = getParsedErrorResponse(err.response)

      const bodyLogMessage = `${message}. ${httpMethod} ${httpUrl}`
      const isUnauthorized = err.response.status === 401
      const logFn = isUnauthorized ? log.info : log.error
      const logContext = {
        customInfo: {
          origin: 'network-interceptor' as const,
          data: {
            method: httpMethod && httpMethod.toLocaleUpperCase(),
            url: httpUrl,
            body: httpBody,
            statusCode: err.response.status,
          },
        },
      }

      logFn(bodyLogMessage, logContext)
    }
  }
}
